<template>
  <div class="masonry">
    <masonry
      :cols="{default: 4, 992: 3, 768: 2, 576: 1}"
      :gutter="25"
    >
      <div
        class="masonry__item" 
        v-for="(photo, index) in items"
        :key="photo.md"
        @click="selectPhoto(index)"
      >
        <HMTImageWatermark
          v-if="getUnpaid" 
          :src="photo.md" 
        />
        <HMTImageWrapper 
          v-else
          :loaderSize="80"
        >
          <lazy-image :src="photo.md" />
        </HMTImageWrapper>
        <span class="masonry__item-icon">
          <FontAwesomeIcon icon="search" />
        </span>
      </div>
    </masonry>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import HMTImageWatermark from '@/shared/components/ImageWatermark';
  import HMTImageWrapper from '@/shared/components/ImageWrapper';

  export default {
    name: 'Masonryc',
    components: {
      HMTImageWatermark,
      HMTImageWrapper
    },
    props: {
			items: {
				type: Array
			}
		},
    computed: {
      ...mapGetters('tour', ['getUnpaid'])
    },
    methods: {
      selectPhoto (photoIndex) {
        this.$emit('onSelectItem', photoIndex);
      }
    }
  };
</script>

<style lang="scss">
  @import '../../../styles/mixins.scss';

  .masonry {
    &__item {
      $item: &;

      position: relative;
      cursor: pointer;
      overflow: hidden;
      width: 100%;
      margin-bottom: 25px;

      &:hover {
        &:before, #{$item}-icon { 
          opacity: 1;
        }
        #{$item}-icon {
          transform: translate(-50%, -50%);
        }
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.7);
        opacity: 0;
        transition: opacity .2s ease-out;
      }

      img {
        width: 100%;
        min-height: 150px;
        vertical-align: middle;
      }

      &-icon {
        position: relative;
        z-index: 5;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, 50%);
        width: 40px;
        height: 40px;
        background-color: #fff;
        border-radius: 50%;
        opacity: 0;
        transition: opacity .2s ease-out, transform .25s ease-out .05s;

        &:before {
          content: '';
          position: absolute;
          width: 62px;
          height: 62px;
          background-color: rgba(255, 255, 255, .2);
          border-radius: 50%;
        }

        .fa-search {
          position: relative;
          z-index: 1;
          color: #222;
        }
      }
    }
  }
</style>
